/**
 * Enum Đã lập hồ sơ
 * nmtuan4 26.4.2023
 */
export default {
  Created: 1,
  NotCreated: 0,
};
